import { defineStore } from "pinia";

export const useSettingsStore = defineStore("settings", {
  state: () => ({
    drawerMini: false,
    airlineDrawerMini: false,
    showSimData: false,
    user: {
      data: {
        _id: "",
        email: "",
        fullname: "",
      },
      avatarUrl: "",
      isLoggedIn: false,
    },
    darkMode: true,
    overlay: {
      enabled: true,
    },
    discord: {
      richPresence: true,
    },
    networked: {
      enabled: false,
      sim: "msfs",
      host: "",
      port: 500,
    },
    map: {
      airportOpacity: 0.7,
      mapMode: "flat",
      airportMode: "normal",
      rainOpacity: 0.2,
      cloudOpacity: 0,
    },
    flightplanning: {
      ofpFormat: "LIDO",
      units: "KGS",
    },
    traffic: {
      enable: true,
      mode: "all",
      range: 40,
      limit: 50,
      modelMatchingFiles: [],
    },
  }),
  getters: {
    userLoggedIn() {
      return this.user.isLoggedIn;
    },
    userData() {
      return this.user.data;
    },
    userAvatarUrl() {
      return this.user.avatarUrl;
    },
    userId() {
      return this.user.data._id;
    },
  },
  actions: {
    logIn(payload) {
      this.user = {
        data: payload.data,
        avatarUrl: payload.avatarUrl,
        isLoggedIn: true,
      };
    },
    userCheckRole(role) {
      return this.user.data.roles && this.user.data.roles.includes(role);
    },
    updateAvatarUrl(avatarUrl) {
      this.user.avatarUrl = avatarUrl;
    },
    logOut() {
      this.user = {
        data: {
          _id: "",
          email: "",
          fullname: "",
        },
        avatarUrl: "",
        isLoggedIn: false,
      };
    },
  },
  persist: true,
});
